import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { TranslationModule } from '@lib/translation';

import { SnTitleComponent } from './components/title/title.component';
import { SnTitleService } from './services/title.service';

@NgModule({
  imports: [CommonModule, TranslationModule],
  exports: [SnTitleComponent],
  declarations: [SnTitleComponent],
})
export class SnTitleModule {
  public static forRoot(): ModuleWithProviders<SnTitleModule> {
    return {
      ngModule: SnTitleModule,
      providers: [SnTitleService],
    };
  }

  constructor(title: SnTitleService) {}
}
